<template>
  <v-dialog v-model="openModal" max-width="600px">
    <v-card>
      <v-toolbar
        elevation="0"
        color="background"
        class="fluid-toolbar mb-0 px-0"
        height="64"
      >
        <v-toolbar-title
          :class="{
            'newTitle--text text-h6': $vuetify.theme.dark,
          }"
          class="mr-0"
        >
          {{ $t('message.pages.customizeModal.autoRechargeConfig') }}
        </v-toolbar-title>
        <v-spacer></v-spacer>
        <v-toolbar-items>
          <v-btn icon @click="handleClose" class="no-ripple mdi-icon">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar-items>
      </v-toolbar>
      <v-card-text class="pb-0">
        <v-container class="py-0">
          <v-row
            style="
              border: 1px solid rgba(208, 209, 217, 0.5);
              justify-content: space-around;
            "
            class="my-4"
          >
            <v-col cols="12" md="3" class="center-content py-4 ml-4">
              <div class="settings-control div-align">
                <label class="label-settings"
                  >{{ $t('message.pages.customizeModal.triggerLabel1')
                  }}<br />{{
                    $t('message.pages.customizeModal.triggerLabel2')
                  }}</label
                >
                <div class="py-2">
                  <v-row align="center" no-gutters class="no-wrap">
                    <v-btn
                      icon
                      @click="decrease('trigger')"
                      class="border-btn-right btn-settings-left"
                    >
                      <v-icon>mdi-minus</v-icon>
                    </v-btn>
                    <v-menu
                      v-model="triggerMenu"
                      offset-y
                      :close-on-content-click="true"
                      :nudge-width="0"
                      :nudge-top="0"
                      :open-on-click="false"
                      :close-on-click="false"
                      max-width="auto"
                      min-width="auto"
                      transition="scale-transition"
                      class="box-shadow-adjust"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="settings.trigger"
                          ref="textFieldTrigger"
                          hide-details
                          class="center-text pa-0 ma-0 border-solid trigger-menu"
                          :class="{
                            'newTitle--text text-h6': $vuetify.theme.dark,
                          }"
                          type="number"
                          min="128"
                          step="128"
                          style="width: 78px"
                          suffix="GB"
                          v-bind="attrs"
                          v-on="on"
                          @input="validateInput"
                          @blur="handleInputValue"
                          @dblclick="handleDblClick('trigger')"
                          @click="handleClick('trigger')"
                        ></v-text-field>
                      </template>
                      <v-list class="dropdown-list div-align" dense>
                        <v-list-item
                          v-for="item in filteredOptions"
                          class="px-3"
                          :key="item"
                          @click="selectOption(item, 'trigger')"
                        >
                          <v-list-item-title class="dropdown-settings"
                            >{{ item }} GB</v-list-item-title
                          >
                        </v-list-item>
                        <v-list-item v-if="filteredOptions.length === 0">
                          <v-list-item-title
                            class="dropdown-settings"
                            v-html="
                              $t(
                                'message.pages.customizeModal.emptyStateDropdown'
                              )
                            "
                          ></v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <v-btn
                      icon
                      @click="increase('trigger')"
                      class="border-btn-left btn-settings-right"
                      :class="{ primary: $vuetify.theme.dark }"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </v-row>
                </div>
                <span class="center-content">{{
                  $t('message.pages.customizeModal.triggerMin')
                }}</span>
              </div>
            </v-col>
            <v-icon class="mx-2 mt-2 icon-opacity">mdi-chevron-right</v-icon>
            <v-col cols="12" md="3" class="center-content py-4">
              <div class="settings-control div-align">
                <label class="label-settings">{{
                  $t('message.pages.customizeModal.autoRechargeAction')
                }}</label>
                <div class="py-2">
                  <v-row align="center" no-gutters class="no-wrap">
                    <v-btn
                      icon
                      @click="decrease('action')"
                      class="border-btn-right btn-settings-left"
                    >
                      <v-icon>mdi-minus</v-icon>
                    </v-btn>
                    <v-menu
                      v-model="actionMenu"
                      offset-y
                      :close-on-content-click="true"
                      :nudge-width="0"
                      :nudge-top="0"
                      :open-on-click="false"
                      :close-on-click="false"
                      max-width="auto"
                      min-width="auto"
                      transition="scale-transition"
                      class="box-shadow-adjust"
                    >
                      <template v-slot:activator="{ on, attrs }">
                        <v-text-field
                          v-model="settings.action"
                          ref="textFieldAction"
                          hide-details
                          class="center-text pa-0 ma-0 border-solid action-menu"
                          :class="{
                            'newTitle--text text-h6': $vuetify.theme.dark,
                          }"
                          type="number"
                          min="128"
                          step="128"
                          max="1280"
                          style="width: 78px"
                          suffix="GB"
                          v-bind="attrs"
                          v-on="on"
                          @input="validateInput"
                          @blur="handleInputValue"
                          @dblclick="handleDblClick('action')"
                          @click="handleClick('action')"
                        ></v-text-field>
                      </template>
                      <v-list class="dropdown-list div-align" dense>
                        <v-list-item
                          v-for="item in filteredOptions"
                          class="px-3"
                          :key="item"
                          @click="selectOption(item, 'action')"
                        >
                          <v-list-item-title class="dropdown-settings"
                            >{{ item }} GB</v-list-item-title
                          >
                        </v-list-item>
                        <v-list-item v-if="filteredOptions.length === 0">
                          <v-list-item-title
                            class="dropdown-settings"
                            v-html="
                              $t(
                                'message.pages.customizeModal.emptyStateDropdown'
                              )
                            "
                          ></v-list-item-title>
                        </v-list-item>
                      </v-list>
                    </v-menu>
                    <v-btn
                      icon
                      @click="increase('action')"
                      class="border-btn-left btn-settings-right"
                      :class="{ primary: $vuetify.theme.dark }"
                    >
                      <v-icon>mdi-plus</v-icon>
                    </v-btn>
                  </v-row>
                </div>
                <span class="center-content">{{
                  $t('message.pages.customizeModal.triggerMin')
                }}</span>
              </div>
            </v-col>
            <v-icon class="mt-2 icon-opacity equal-icon-adjust"
              >mdi-equal</v-icon
            >
            <v-col cols="12" md="3" class="center-content pl-6">
              <div class="settings-control">
                <label class="label-settings pt-2">Total</label>
                <v-row
                  align="center"
                  no-gutters
                  style="justify-content: center"
                  class="mt-4"
                >
                  <div
                    class="total-settings center-content"
                    :style="
                      $vuetify.theme.dark
                        ? 'color: #ffffff'
                        : 'color: var(--v-brand-darken1)'
                    "
                  >
                    {{ currencySign }} {{ calculateTotal() }}
                  </div>
                </v-row>
                <span class="center-content pt-2"
                  >{{ currencySign }}
                  {{ $t('message.pages.customizeModal.storagePrice') }}</span
                >
              </div>
            </v-col>
          </v-row>
        </v-container>
      </v-card-text>
      <v-card-actions class="pb-6 pr-6">
        <v-spacer></v-spacer>
        <BaseBtn
          v-if="isAutoRechargeEnabled"
          type="primary"
          @click="updateAutoRecharge"
          :loading="autoRechargeSettingsLoading"
          :disabled="!hasChanges || requestSuccess || requestError"
        >
          <template>{{
            $t('message.pages.customizeModal.autoRechargeEdit')
          }}</template>
        </BaseBtn>
        <BaseBtn
          v-else
          type="primary"
          @click="activateAutoRecharge"
          :loading="autoRechargeSettingsLoading"
          :disabled="requestError"
          >{{ $t('message.pages.customizeModal.toggleAutoRecharge') }}</BaseBtn
        >
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>

<script>
import BaseBtn from '@/components/BaseBtn.vue'
import planApi from '@/services/planApi'
import _ from 'lodash'
import { mapMutations } from 'vuex'
import i18n from '@/translations/lang'

export default {
  components: {
    BaseBtn,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    isAutoRechargeEnabled: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      openModal: false,
      settings: {
        trigger: 128,
        action: 128,
      },
      triggerMenu: false,
      actionMenu: false,
      options: [],
      autoRechargeSettingsLoading: null,
      initialSettings: null,
      hasChanges: null,
      requestSuccess: null,
      requestError: null,
      isCardPaymentSource: true,
      clickTimeout: null,
    }
  },
  computed: {
    currencySign() {
      let currencySign = 'R$'
      const currency = this.$root.$store.state.user.userPlanInfo.currency
      if (currency !== 'brl') {
        currencySign = '$'
      }
      return currencySign
    },
    inputTextColor() {
      return this.$vuetify.theme.dark ? '#ffffff' : '#636578'
    },
    totalBackgroundColor() {
      return this.$vuetify.theme.dark ? '#061879' : '#EBEEFF'
    },
    filteredOptions() {
      const input = this.triggerMenu
        ? this.settings.trigger
        : this.settings.action
      if (input === '') return this.options
      return this.options.filter((item) => item.toString().startsWith(input))
    },
  },
  watch: {
    value(newVal) {
      this.openModal = newVal
    },
    openModal(newVal) {
      const _this = this
      if (newVal) {
        setTimeout(() => {
          _this.addClickListener()
        }, 500)
        if (this.isAutoRechargeEnabled) {
          this.hasChanges = false
        }
        this.initialSettings = _.cloneDeep(this.settings)
      }
      this.$emit('input', newVal)
    },
    inputTextColor(newColor) {
      document.documentElement.style.setProperty('--input-text-color', newColor)
    },
    totalBackgroundColor(newColor) {
      document.documentElement.style.setProperty(
        '--total-background-color',
        newColor
      )
    },
    settings: {
      handler() {
        this.checkChanges()
      },
      deep: true,
    },
    requestSuccess(success) {
      if (success) {
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: i18n.t('message.pages.customizeModal.autoRechargeSuccess'),
          type: 'success',
        })
      }
    },
    requestError(error) {
      const errorMessage = this.isCardPaymentSource
        ? 'autoRechargeError'
        : 'autoRechargeNoCreditCardTooltip'
      if (error) {
        this.UPDATE_GLOBAL_SNACKBAR({
          open: true,
          text: i18n.t(`message.pages.customizeModal.${errorMessage}`),
          type: 'error',
        })
      }
    },
  },
  created() {
    this.generateOptions()
  },
  mounted() {
    this.setInputTextColor()
    this.setTotalBackgroundColor()
    this.$root.$on('updateSettingsValues', (trigger, action) => {
      this.settings.trigger = trigger
      this.settings.action = action
    })
    this.$root.$on('autoRechargeDisabled', () => {
      this.initialSettings = null
      this.hasChanges = null
      this.requestSuccess = null
      this.UPDATE_GLOBAL_SNACKBAR({
        open: true,
        text: i18n.t('message.pages.customizeModal.autoRechargeSuccess'),
        type: 'success',
      })
    })
    this.$root.$on('paymentSourceType', (type) => {
      if (type !== 'card') {
        this.isCardPaymentSource = false
      }
    })
  },
  methods: {
    ...mapMutations('user', ['UPDATE_GLOBAL_SNACKBAR']),
    increase(setting) {
      if (this.settings[setting] < 10112) {
        this.settings[setting] += 128
      }
    },
    decrease(setting) {
      if (this.settings[setting] > 128) {
        this.settings[setting] -= 128
      }
    },
    calculateTotal() {
      let factor = 0.18
      const currency = this.currencySign
      if (currency === '$') {
        factor = 0.06
      }
      return (this.settings.action * factor).toFixed(2)
    },
    async activateAutoRecharge() {
      this.autoRechargeSettingsLoading = true
      const settings = this.settings
      try {
        if (this.isCardPaymentSource === false)
          throw new Error('Payment method is not valid')
        await planApi.activeAutoRecharge(settings)
        this.updateVariablesOnSuccess()
        this.$root.$emit('isAutoRechargeEnabled', true, this.settings)
      } catch (error) {
        console.error(error)
        this.requestError = true
        this.autoRechargeSettingsLoading = false
      }
    },
    async updateAutoRecharge() {
      this.autoRechargeSettingsLoading = true
      const settings = this.settings
      try {
        await planApi.updateAutoRecharge(settings)
        this.updateVariablesOnSuccess()
        this.$root.$emit('isAutoRechargeEnabled', true, this.settings)
      } catch (error) {
        console.error(error)
        this.requestError = true
        this.autoRechargeSettingsLoading = false
      }
    },
    handleClose() {
      this.openModal = false
      this.requestSuccess = false
      this.requestError = false
    },

    selectOption(option, val) {
      this.settings[val] = option
      if (val === 'action') {
        this.triggerMenu = false
      } else {
        this.actionMenu = false
      }
    },
    generateOptions() {
      for (let i = 128; i <= 10112; i += 128) {
        this.options.push(i)
      }
    },
    addClickListener() {
      this.addSuffixClickListener(
        this.$refs.textFieldTrigger,
        () => (this.triggerMenu = true)
      )
      this.addSuffixClickListener(
        this.$refs.textFieldAction,
        () => (this.actionMenu = true)
      )
    },
    addSuffixClickListener(textField, callback) {
      this.$nextTick(() => {
        const suffixElement = textField.$el.querySelector(
          '.v-text-field__suffix'
        )
        if (suffixElement) {
          suffixElement.addEventListener('click', callback)
        }
      })
    },
    setInputTextColor() {
      document.documentElement.style.setProperty(
        '--input-text-color',
        this.inputTextColor
      )
    },
    setTotalBackgroundColor() {
      document.documentElement.style.setProperty(
        '--total-background-color',
        this.totalBackgroundColor
      )
    },
    checkChanges() {
      this.requestSuccess = false
      const isEqual = _.isEqual(this.initialSettings, this.settings)
      if (isEqual) {
        this.hasChanges = false
      } else {
        this.hasChanges = true
      }
    },
    updateVariablesOnSuccess() {
      this.autoRechargeSettingsLoading = false
      this.requestSuccess = true
      this.initialSettings = _.cloneDeep(this.settings)
      this.hasChanges = false
      this.openModal = false
    },
    validateInput() {
      const input = this.triggerMenu
        ? this.settings.trigger
        : this.settings.action
      const objectKey = this.triggerMenu ? 'trigger' : 'action'

      if (input.startsWith('0')) {
        this.triggerBlur(objectKey)
        return
      }
      if (!this.options.some((option) => option.toString().startsWith(input))) {
        this.settings[objectKey] = ''
      }
    },
    handleInputValue() {
      const triggerLength = this.settings.trigger.toString().length
      const actionLength = this.settings.action.toString().length
      const triggerValue = Number(this.settings.trigger)
      const actionValue = Number(this.settings.action)

      if (triggerLength == 0 || !this.options.includes(triggerValue))
        this.settings.trigger = this.initialSettings.trigger
      if (actionLength == 0 || !this.options.includes(actionValue))
        this.settings.action = this.initialSettings.action
      setTimeout(() => {
        this.triggerMenu = false
        this.actionMenu = false
      }, 100)
    },
    triggerBlur(target) {
      const elementTarget =
        target === 'trigger' ? 'textFieldTrigger' : 'textFieldAction'
      if (this.$refs[elementTarget] && this.$refs[elementTarget].$el) {
        this.$refs[elementTarget].$el.querySelector('input').blur()
        setTimeout(() => {
          this.triggerMenu = false
          this.actionMenu = false
        }, 100)
      }
    },
    handleDblClick(target) {
      const targetMenu = target === 'trigger' ? 'triggerMenu' : 'actionMenu'
      clearTimeout(this.clickTimeout)
      setTimeout(() => {
        this[targetMenu] = true
      }, 200)
    },
    handleClick(target) {
      const targetMenu = target === 'trigger' ? 'triggerMenu' : 'actionMenu'
      this.clickTimeout = setTimeout(() => {
        this[targetMenu] = true
      }, 100)
    },
  },
}
</script>

<style lang="scss" scoped>
.settings-control label {
  display: block;
  font-weight: bold;
}
.settings-control span {
  font-size: 12px;
  color: gray;
}
::v-deep div.v-input.center-text {
  div.v-input__control {
    padding: 1px;
    .v-input__slot {
      .v-text-field__slot {
        input {
          text-align: center;
          color: var(--input-text-color);
          font-size: 14px;
        }
        .v-text-field__suffix {
          margin-left: -10px;
          margin-right: 10px;
          color: var(--input-text-color);
          font-size: 14px;
        }
      }
    }
  }
}
::v-deep .v-text-field > .v-input__control > .v-input__slot:before {
  border: none !important;
}
.v-btn--round {
  border-radius: 0;
}
.center-content {
  display: flex;
  align-items: center;
  justify-content: center;
}
.label-settings {
  text-align: center;
  width: 127px;
  line-height: 16px;
}
.border-solid {
  border: 1px solid rgba(208, 209, 217, 0.5);
}
.no-side-border {
  border-left: 0;
  border-right: 0;
}
.btn-settings-left {
  border-top-left-radius: 4px;
  border-bottom-left-radius: 4px;
  background-color: rgb(235, 237, 255);
  transition: all 0.2s ease;
  &.theme--light {
    &:hover {
      background-color: #ebedff !important;
    }
  }
  &.theme--dark {
    &:hover {
      background-color: #d2d3d4 !important;
    }
  }
}
.btn-settings-right {
  border-top-right-radius: 4px;
  border-bottom-right-radius: 4px;
  transition: all 0.2s ease;
  &.theme--light {
    background-color: var(--v-brand-base);
    &:hover {
      background-color: #0f22a1 !important;
    }
  }
  &.theme--dark {
    &:hover {
      background-color: #3f55ee !important;
    }
  }
}
::v-deep .border-btn-left > .v-btn__content > .v-icon {
  color: white !important;
}
::v-deep .border-btn-right > .v-btn__content > .v-icon {
  color: #000000 !important;
}
.no-wrap {
  flex-wrap: nowrap !important;
}
.total-settings {
  height: 40px;
  width: 100px;
  background-color: var(--total-background-color);
  border-radius: 4px;
}
.icon-opacity {
  color: #d0d1d9;
}
.equal-icon-adjust {
  margin-right: -15px;
  margin-left: 15px;
}
::v-deep .v-text-field > .v-text-field--enclosed > .v-text-field__slot input {
  width: calc(100% - 40px);
}
.div-align {
  display: flex;
  flex-direction: column;
  align-items: center;
}
::v-deep .v-toolbar__content {
  padding-left: 24px !important;
  padding-right: 8px !important;
}
.dropdown-list {
  max-height: 120px;
  width: 78px;
  overflow-y: scroll;
  overflow-x: hidden;
}
.box-shadow-adjust {
  box-shadow: 0px 5px 5px -3px rgba(0, 0, 0, 0.2),
    0px 8px 10px 1px rgba(0, 0, 0, 0.14);
}
.dropdown-list {
  -ms-overflow-style: none; /* IE and Edge */
  scrollbar-width: none; /* Firefox */
}
.dropdown-list::-webkit-scrollbar {
  display: none; /* Safari and Chrome */
  width: 0;
  height: 0;
}
.dropdown-settings {
  text-align: center;
  font-size: 12px !important;
  font-weight: 400 !important;
  &.theme--light {
    color: gray;
  }
  &.theme--dark {
    color: white;
    &:hover {
      background-color: #3f55ee !important;
    }
  }
}
.add-cursor-pointer {
  cursor: pointer;
}
::v-deep .v-text-field__suffix {
  cursor: pointer;
}
</style>
